import { TableLimitlistingOptions } from "constants"
import React, { useMemo } from "react"

const PageLimit = ({
    // pageSize,
    changePageSizeHandler,
    page = 1,
    pageSize = 10,
    total = 0,
    typoClasses = "",
    selectClasses = "",
    mainClass = "",
}) => {
    const shownItemsCount = useMemo(() => {
        return pageSize === -1 ? total : Math.min(page * pageSize, total)
    }, [pageSize, page, total])

    const selectChangeHandler = event => {
        let pageLimit = Number(event.target.value)
        console.log("pageLimit", pageLimit)
        changePageSizeHandler(pageLimit)
    }
    return (
        <>
            <div className={`my-3 pagelimit-container ${mainClass}`}>
                {/* <span className={`ms-0 ms-md-2 me-2 ${typoClasses}`}>Show</span> */}
                <div className="selector-container">
                    <select
                        className={`${selectClasses}`}
                        value={pageSize}
                        onChange={selectChangeHandler}
                    >
                        {TableLimitlistingOptions.map(item => (
                            <option key={item} value={item.value}>
                                {item.label}
                            </option>
                        ))}
                    </select>

                    {/* <span className={`mx-2 ${typoClasses}`}>Entries</span> */}
                    <div className="selector-records">
                        Showing {shownItemsCount} of {total}
                    </div>
                </div>
            </div>
        </>
    )
}

export default PageLimit
